import React from "react";
import Img from "../../../../assets/images/image";
import WhatMakesUsDifferent from "../../../../Components/WhatMakesUsDifferent";
import GetInTouch from "../../../../Components/GetInTouch";
import { data } from "../../../../Data/data";
import { Helmet } from "react-helmet";
import TwoColumn from "../../../../Components/TwoColumn";
import HeroSection from "../../../../Components/HeroSection/HeroSection";

const QATesting = () => {
   return (
      <div className="animation fadeIn">
         <Helmet>
            <title>QA Testing</title>
            <meta
               name="description"
               content="Witmates assures exceptional quality for your next project. We perform extensive QA testing on multiple devices & platforms to ensure trouble-free software."
            />
            <link rel="canonical" href="https://www.witmates.com/qa_testing" />
         </Helmet>
         <HeroSection
            image={Img.qaTestingBanner}
            heading={
               <>
                  Ensure <span className="witmates-theme-color">Superior</span> Quality <br /> & Reliability with Our <br /> Rigorous <span className="witmates-theme-color">QA Testing</span>
               </>
            }
            description={
               <>
                  Our team of highly skilled QA testers uses a meticulous approach to software testing, leaving no room for compromise. We conduct extensive testing across multiple devices, platforms,
                  and environments to guarantee a trouble-free software experience.
               </>
            }
            link
         />
         <section className="pt100 pb100 mobPt50 mobPb20">
            <div className="d-flex justify-content-center align-items-center">
               <TwoColumn
                  image={Img.qaSide}
                  heading={
                     <>
                        Quality Assurance <br /> and Testing
                     </>
                  }
                  pageName="QA & TESTING"
                  buttonName="BUILD TOGETHER"
                  redirection="/get-in-touch"
                  subPoints={["Web Testing Automation", "Manual QA Testing", "Mobile App Testing"]}
                  isZoom={true}
                  description={
                     <>
                        At Witmates, our expert QA testers perform thorough software testing practices based on multiple parameters like scalability, functionality, behaviour, compatibility,
                        performance etc. and ensure trouble-free software with our dependable QA testing services.
                        <br />
                        From functionality and performance to security and compatibility, we take every aspect to the light and ensure that your software operates flawlessly in the real world.
                        <br />
                        With our reliable QA testing services, you can rest assured that your software meets the highest quality standards. We take pride in delivering software that not only functions
                        flawlessly but also provides a seamless and intuitive user experience.
                        <br />
                        Our team of experienced engineers and testers are dedicated to providing the best quality assurance services. So, when you choose us as your partner, you can trust that your
                        software has undergone meticulous testing and validation.
                     </>
                  }
               />
            </div>
         </section>
         <WhatMakesUsDifferent data={data.QaTestingData} height="340px" />
         <GetInTouch />
      </div>
   );
};

export default QATesting;
